import React, { useEffect, useMemo, useState } from 'react';
import { ArcherElement } from 'react-archer';
import { Number as N } from 'effect';
import { set } from 'lodash/fp';
import { TwoWayMatchAnchors } from '@/components/TwoWayMatch/matching';

export const TwoWayMatchRowMarker = ({
  rowEndCell,
  relations: { relation, color, jeLineKey },
  point,
  width,
  height,
  scale,
}) => {
  const markerSize = 6 * scale;
  const [hovered, setHovered] = useState(false);

  const relations = useMemo(
    () =>
      hovered
        ? [set(['style', 'strokeColor'], color.border)(relation)]
        : [set(['style', 'strokeColor'], 'transparent')(relation)],
    [hovered, relation, color.border],
  );

  // Centred on the row's end edge, and kept whole inside the page when the table reaches the page's edge.
  const position = useMemo(() => {
    const radius = markerSize / 2;
    return {
      width: markerSize,
      height: markerSize,
      left: N.clamp(width * point.X, { minimum: radius, maximum: width - radius }) - radius,
      top: N.clamp(height * point.Y, { minimum: radius, maximum: height - radius }) - radius,
    };
  }, [markerSize, point, width, height]);

  useEffect(() => {
    if (hovered) {
      const anchor = TwoWayMatchAnchors.jeLineElementId(jeLineKey);

      const el = document.getElementById(anchor);

      el?.scrollIntoView({ block: 'nearest' });
    }
  }, [hovered, jeLineKey]);

  return (
    <ArcherElement id={TwoWayMatchAnchors.rowElementId(rowEndCell.id)} relations={relations}>
      <div
        id={TwoWayMatchAnchors.rowMarkerElementId(rowEndCell.id)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: 'absolute',
          background: color.border,
          // Above the page's OCR word layer, which takes the pointer over the whole page.
          zIndex: 101,
          borderRadius: '50%',
          ...position,
        }}
      />
    </ArcherElement>
  );
};
